import React, { useState } from "react";
import "./fourthpage.css";

const FourthPage = () => {
 const [angle, setAngle] = useState(0);

 const rotatePrev = () => {
    setAngle((prevAngle) => prevAngle + 22.5);
    console.log("next btn");
 };

 const rotateNext = () => {
    setAngle((prevAngle) => prevAngle - 22.5);
    console.log("prev btn");
 };

 return (
    <div className="holder" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <div className="spinner" style={{ "--ang": `${angle}deg` }}>
        <div
          className="panel a"
          
        ></div>
        <div
          className="panel b"
          
        ></div>
        <div
          className="panel c"
          
        ></div>
        <div
          className="panel d"
          
        ></div>
        <div
          className="panel e"
          
        ></div>
        <div
          className="panel f"
          
        ></div>
        <div
          className="panel g"
          
        ></div>
        <div
          className="panel h"
          
        ></div>
        <div
          className="panel i"
          s
        ></div>
        <div
          className="panel j"
          
        ></div>
        <div
          className="panel k"
          
        ></div>
        <div
          className="panel l"
          
        ></div>
        <div
          className="panel m"
          
        ></div>
        <div
          className="panel n"
          
        ></div>
        <div
          className="panel o"
          
        ></div>
        <div
          className="panel p"
          
        ></div>
        
        <div className="fade"></div>
      </div>
      <div className="pagination" style={{ marginTop: "20px" }}>
        <button type="button" id="prev" onClick={rotatePrev}>&#8592;</button>
        <button type="button" id="next" onClick={rotateNext}>&#8594;</button>
      </div>
    </div>
 );
};

export default FourthPage;
